import api from "./index";
import { AxiosResponse } from "axios";
import { AuthorizationInterface, UserType } from "../types";

export const authorize = async (token?: string | null) => {
  const additionalParams = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {};
  const { data }: { data: { data?: AuthorizationInterface } } = await api.get(
    "/v1/authorization",
    { ...additionalParams }
  );
  return data?.data;
};

export const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<any> => {
  const params = new URLSearchParams();
  params.append("username", email);
  params.append("password", password);
  params.append("grant_type", "password");
  params.append("client_id", import.meta.env.VITE_CLIENT_ID as string);
  params.append("client_secret", import.meta.env.VITE_CLIENT_SECRET as string);
  const { data }: AxiosResponse = await api.post("/oauth2/token", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  localStorage.setItem("token", data.access_token);
  return data;
};

export const getUserMembership = async (): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.get(`/v1/user/memberships`);
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const getUserInvitations = async (userId: number): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.get(`/v1/users/${userId}/invitations`);
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const rejectUserInvitations = async (
  invitationId: number
): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.post(
      `/v1/invitations/${invitationId}/_reject`
    );
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const acceptUserInvitations = async (
  invitationId: number
): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.post(
      `/v1/invitations/${invitationId}/_accept`
    );
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const deleteUser = async (userId: number): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.delete(`/v1/users/${userId}`);
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const updateUser = async (
  userId: number,
  userData: UserType
): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.patch(`/v1/users/${userId}`, userData);
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const updatePassword = async (
  userId: number,
  password: string
): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.patch(`/v1/users/${userId}/password`, {
      password,
    });
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const forgotPassword = async (email: string): Promise<any> => {
  try {
    const { data }: AxiosResponse = await api.post(
      `/v1/forgotpassword?email=${encodeURIComponent(email)}`
    );
    return data;
  } catch (err: unknown) {
    throw err;
  }
};

export const resetPasswordFromGuid = async (
  userId: number,
  password: string,
  guid: string
): Promise<any> => {
  try {
    const {
      data: { data },
    }: AxiosResponse = await api.patch(`/v1/users/${userId}/passwordguid`, {
      password,
      guid,
    });
    return data;
  } catch (err: unknown) {
    throw err;
  }
};
